// extracted by mini-css-extract-plugin
export default {"error":"styles_error__uYrWF","login":"styles_login__TkusH","passwordValidation":"styles_passwordValidation__XX-Zh"};